import React from 'react';
export function Footer() {
  return <footer className="w-full py-8 border-t" style={{
    borderColor: 'var(--color-border)',
    backgroundColor: 'var(--color-cream)'
  }} data-id="element-35">
      <div className="max-w-3xl mx-auto px-4 text-center space-y-3" data-id="element-36">
        <p className="font-handwritten text-2xl" style={{
        color: 'var(--color-brown)'
      }} data-id="element-37">
          Napftagebuch
        </p>
        <p className="text-xs leading-relaxed max-w-md mx-auto" style={{
        color: 'var(--color-text-light)'
      }} data-id="element-38">
          Dieser Beitrag basiert auf meiner persönlichen Erfahrung. Ergebnisse
          können individuell variieren. Bei anhaltenden gesundheitlichen
          Problemen deines Hundes konsultiere bitte einen Tierarzt.
        </p>
        <p className="text-xs" style={{
        color: 'var(--color-text-light)'
      }} data-id="element-39">
          Produkt von{' '}
          <a href="https://hunderunde.shop" target="_blank" rel="noopener noreferrer" className="underline hover:no-underline" style={{
          color: 'var(--color-green)'
        }} data-id="element-40">
            hunderunde.shop
          </a>
        </p>
      </div>
    </footer>;
}